/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { isNavigationAction } from "../../enums/InputAction";
import type { TInputEvent, InputInterceptor } from "../types/TInputEvent";

/**
 * Blocks repeated non-navigation key events.
 * Navigation keys (D-pad) are allowed to repeat for smooth scrolling.
 */
export function createRepeatGuardInterceptor(): InputInterceptor {
  return (event: TInputEvent): boolean | void => {
    if (event.repeat && !isNavigationAction(event.action)) {
      return true;
    }
  };
}
